export enum AppRoutePath {
  BasePath = '',
  AuthPath = 'auth',
  SearchPath = 'search',
  ResultsPath = 'results',
  DetailPath = 'detail',
  ComparePath = 'compare',
  PortfolioAnalysisPath = 'portfolio-analysis',
  EmptyStatesPath = 'empty-states',
  LegalPath = 'legal',
}
